import { z } from 'zod'
import { Validate } from './SchemaValidation'
import { env } from '../configs/EnvironmentConfig'
import fetch from 'auth/FetchInterceptor'

const ReverseProxyService = {}

const routeSchema = z.object({
  domain_id: z.number(),
  sub_domain: z.string().optional(),
  path: z.string().optional(),
})

const serviceSchema = z.object({
  vps_id: z.string().uuid(),
  https: z.boolean(),
  name: z.string().optional(),
  port: z.number(),
  path: z.string().optional(),
})

const reverseProxySchema = z.object({
  enable: z.boolean().optional(),
  routes: z.array(routeSchema).min(0),
  service_urls: z.array(serviceSchema).min(0),
})

const paginationSchema = z.object({
  page: z.number().optional(),
  limit: z.number().optional(),
})

const numberId = z.number()

ReverseProxyService.getReverseProxyList = params => {
  Validate(paginationSchema, params)
  const { page, limit } = params
  return fetch({
    url: `${env.PROXY_ENDPOINT_URL}/api/reverse-proxy?page=${page || 1}&limit=${
      limit || 10
    }`,
    method: 'GET',
  })
}

ReverseProxyService.deleteReverseProxy = id =>
  fetch({
    url: `${env.PROXY_ENDPOINT_URL}/api/reverse-proxy/${Validate(
      numberId,
      id
    )}`,
    method: 'DELETE',
  })

ReverseProxyService.getReverseProxy = id =>
  fetch({
    url: `${env.PROXY_ENDPOINT_URL}/api/reverse-proxy/${Validate(
      numberId,
      id
    )}`,
    method: 'GET',
  })

ReverseProxyService.createReverseProxy = data =>
  fetch({
    url: `${env.PROXY_ENDPOINT_URL}/api/reverse-proxy`,
    method: 'POST',
    data: Validate(reverseProxySchema, data),
  })

ReverseProxyService.updateReverseProxy = (id, data) =>
  fetch({
    url: `${env.PROXY_ENDPOINT_URL}/api/reverse-proxy/${Validate(
      numberId,
      id
    )}`,
    method: 'PUT',
    data: Validate(reverseProxySchema, data),
  })

ReverseProxyService.getRoutes = reverseProxyId =>
  fetch({
    url: `${env.PROXY_ENDPOINT_URL}/api/reverse-proxy/${Validate(
      numberId,
      reverseProxyId
    )}/route`,
    method: 'GET',
  })

ReverseProxyService.addRoute = (reverseProxyId, data) =>
  fetch({
    url: `${env.PROXY_ENDPOINT_URL}/api/reverse-proxy/${Validate(
      numberId,
      reverseProxyId
    )}/route`,
    method: 'POST',
    data: Validate(routeSchema, data),
  })

ReverseProxyService.editRoute = (reverseProxyId, { routeId, ...data }) =>
  fetch({
    url: `${env.PROXY_ENDPOINT_URL}/api/reverse-proxy/${Validate(
      numberId,
      reverseProxyId
    )}/route/${Validate(numberId, routeId)}`,
    method: 'PUT',
    data: Validate(routeSchema, data),
  })

ReverseProxyService.deleteRoute = ({ reverseProxyId, routeId }) =>
  fetch({
    url: `${env.PROXY_ENDPOINT_URL}/api/reverse-proxy/${Validate(
      numberId,
      reverseProxyId
    )}/route/${Validate(numberId, routeId)}`,
    method: 'DELETE',
  })

ReverseProxyService.deleteService = ({ reverseProxyId, serviceId }) =>
  fetch({
    url: `${env.PROXY_ENDPOINT_URL}/api/reverse-proxy/${Validate(
      numberId,
      reverseProxyId
    )}/service-url/${Validate(numberId, serviceId)}`,
    method: 'DELETE',
  })

ReverseProxyService.editService = ({ reverseProxyId, serviceId, ...data }) =>
  fetch({
    url: `${env.PROXY_ENDPOINT_URL}/api/reverse-proxy/${Validate(
      numberId,
      reverseProxyId
    )}/service-url/${Validate(numberId, serviceId)}`,
    method: 'PUT',
    data: Validate(serviceSchema, data),
  })

ReverseProxyService.createService = ({ reverseProxyId, ...data }) =>
  fetch({
    url: `${env.PROXY_ENDPOINT_URL}/api/reverse-proxy/${Validate(
      numberId,
      reverseProxyId
    )}/service-url`,
    method: 'POST',
    data: Validate(serviceSchema, data),
  })

ReverseProxyService.getServices = reverseProxyId =>
  fetch({
    url: `${env.PROXY_ENDPOINT_URL}/api/reverse-proxy/${Validate(
      numberId,
      reverseProxyId
    )}/service-url`,
    method: 'GET',
  })

ReverseProxyService.resetReverseProxyDnsRecords = reverseProxyId =>
  fetch({
    url: `${env.PROXY_ENDPOINT_URL}/api/reverse-proxy/${Validate(
      numberId,
      reverseProxyId
    )}/reset-dns-records`,
    method: 'PATCH',
  })

export default ReverseProxyService
